import type { FC } from "react";
import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { IconButton } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import {
    TitlePagePrevieWrapper,
    TitlePagePreview,
} from "app/pages/digital-marketing/AnalysisHomePageTrial/AnalysisHomePageTrialStyle";
import { openHooksModalV4, openHooksModalV5 } from "app/services/ModalService";
import { isTraditionalTrialUser } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import { PagePreview } from "pro-features/components/PagePreview/PagePreview";

import { siteAuditHomepagePreview } from "./SiteAuditHomePageConsts";
import {
    HomePage,
    HomepageInnerWrapper,
    HeadersSection,
    Title,
    SubTitle,
    LineTitle,
    TitlesHeader,
    HomepageContentWrapper,
} from "./SiteAuditHomePageStyledComponents";
import {allTrackers} from "app/services/track/track";

export const SiteAuditHomepageWrapper: FC = () => {
    const {
        params: { unauthorized },
    } = useCurrentStateAndParams();

    useEffect(() => {
        if (unauthorized) {
            (async () => {
                await openHooksModalV4("siteAudit");
            })();
        }
    }, [unauthorized]);

    const isTrialUser = isTraditionalTrialUser(swSettings);

    const homepagePreview = () => {
        return (
            <HomepageInnerWrapper>
                <TitlePagePrevieWrapper>
                    <LineTitle />
                    <TitlePagePreview>{translate("digitalsuite.site_audit.homepage.line.text")}</TitlePagePreview>
                    <LineTitle />
                </TitlePagePrevieWrapper>
                {siteAuditHomepagePreview.map((pagePreview, index) => {
                    return (
                        <PagePreview
                            key={pagePreview.title}
                            isImageBeforeText={!!(index % 2)}
                            image={pagePreview.image}
                            title={translate(pagePreview.title)}
                            descriptions={pagePreview.descriptions.map((description) => translate(description))}
                        ></PagePreview>
                    );
                })}
            </HomepageInnerWrapper>
        );
    };

    const handleButtonClick = () => {
        allTrackers.dispatchTrackEvent("Button", "click", "clicked site audit CTA");
        if (isTrialUser) {
            openHooksModalV5("siteAudit");
        } else {
            window.open(swSettings.swsites.siteaudit, "_blank");
        }
    };

    return (
        <HomePage className="sw-layout-module-inner sw-layout-scrollable-element">
            <HomepageContentWrapper>
                <HomepageInnerWrapper>
                    <HeadersSection>
                        <TitlesHeader>
                            <Title>{translate("digitalsuite.site_audit.homepage.title")}</Title>
                            <SubTitle>{translate("digitalsuite.site_audit.homepage.subTitle")}</SubTitle>
                        </TitlesHeader>
                        <IconButton
                            type="primary"
                            iconName={isTrialUser ? "sparkles" : "arrow-right"}
                            placement={"right"}
                            onClick={handleButtonClick}
                        >
                            {translate("digitalsuite.site_audit.homepage.start_project_btn_txt")}
                        </IconButton>
                    </HeadersSection>
                </HomepageInnerWrapper>
                {homepagePreview()}
            </HomepageContentWrapper>
        </HomePage>
    );
};
